export default "__VITE_ASSET__0c4a3cb4__"